import { getMessages } from '../../../../../../store/constants';

export const BOARD_SECTION_PREFIXES = getMessages().getText('cardNumber.title');

export const SNACKBAR_BOARD_CARD_PREFIXES_ID = 'SNACKBAR_BOARD_CARD_PREFIXES_ID';
export const SNACKBAR_BOARD_CARD_PREFIXES_TIMER = 9999999999999999999999999; // в kui у undo 10 по делефолту
